export const REFERRAL_PURPLE = '#6350AD';

// Referral list surfaces keep their identity and contrast in either theme.
export const REFERRAL_LIST_COLORS = {
  background: '#E6E7FF',
  selectedBackground: '#CFD1FF',
  text: '#000000',
  icon: REFERRAL_PURPLE,
} as const;
